import en from 'date-fns/locale/en-US'
import es from 'date-fns/locale/es'
import fr from 'date-fns/locale/fr'
import ko from 'date-fns/locale/ko'
import pl from 'date-fns/locale/pl'
import pt from 'date-fns/locale/pt-BR'
import ru from 'date-fns/locale/ru'
import zh from 'date-fns/locale/zh-CN'
import type { SupportedLocales } from '../hooks/useDateFormatters'

const locales = {
  en,
  es,
  fr,
  ko,
  pl,
  pt,
  ru,
  zh,
}

function getCurrentLocale(locale: string): Locale {
  return locales[locale as SupportedLocales] || locales.en
}

export default getCurrentLocale
